import React from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { FaUser } from 'react-icons/fa';
import { educationOptions } from '../utils/validators';

const IdentityForm = ({ isActive, formData, tcError, handleChange, handleNext }) => {
    return (
        <div id="kimlik-form" className={isActive ? 'd-block' : 'd-none'}>
            <h4 className="form-section-title">
                <FaUser className="me-2" /> Kimlik Bilgileri
            </h4>

            <Row className="mb-4">
                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Ad</Form.Label>
                        <Form.Control
                            required
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="Adınız"
                        />
                        <Form.Control.Feedback type="invalid">
                            Lütfen adınızı girin
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Soyad</Form.Label>
                        <Form.Control
                            required
                            type="text"
                            name="surname"
                            value={formData.surname}
                            onChange={handleChange}
                            placeholder="Soyadınız"
                        />
                        <Form.Control.Feedback type="invalid">
                            Lütfen soyadınızı girin
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>

                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>T.C. Kimlik Numarası</Form.Label>
                        <Form.Control
                            required
                            type="text"
                            name="tcNumber"
                            value={formData.tcNumber}
                            onChange={handleChange}
                            placeholder="T.C. Kimlik Numaranız"
                            maxLength={11}
                            isInvalid={!!tcError}
                        />
                        <Form.Control.Feedback type="invalid">
                            {tcError || "Geçerli bir T.C. Kimlik Numarası girin (11 rakam)"}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Doğum Tarihi</Form.Label>
                        <Form.Control
                            required
                            type="date"
                            name="birthDate"
                            value={formData.birthDate}
                            onChange={handleChange}
                        />
                        <Form.Control.Feedback type="invalid">
                            Lütfen doğum tarihinizi girin
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>

                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Cinsiyet</Form.Label>
                        <Form.Select
                            name="gender"
                            value={formData.gender}
                            onChange={handleChange}
                        >
                            <option value="">Seçiniz</option>
                            <option value="erkek">Erkek</option>
                            <option value="kadın">Kadın</option>
                        </Form.Select>
                    </Form.Group>
                </Col>

                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Eğitim Durumu</Form.Label>
                        <Form.Select
                            required
                            name="education"
                            value={formData.education}
                            onChange={handleChange}
                        >
                            <option value="">Seçiniz</option>
                            {educationOptions.map((option, index) => (
                                <option key={index} value={option.value}>{option.label}</option>
                            ))}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                            Lütfen eğitim durumunuzu seçin
                        </Form.Control.Feedback>
                    </Form.Group>
                </Col>
            </Row>

            <div className="d-flex justify-content-end">
                <Button variant="primary" onClick={handleNext}>
                    Devam Et
                </Button>
            </div>
        </div>
    );
};

export default IdentityForm;